import {
  makeStyles,
  Paper,
  Typography,
  Button,
  Divider,
} from "@material-ui/core";
import EmailIcon from "@material-ui/icons/Email";

const Emoji = (props) => (
  <span
    className='emoji'
    role='img'
    aria-label={props.label ? props.label : ""}
    aria-hidden={props.label ? "false" : "true"}
  >
    {props.symbol}
  </span>
);

const Explanation = () => {
  const classes = useStyles();
  return (
    <Paper
      variant='outlined'
      square
      elevation={0}
      className={classes.explanation}
    >
      <Typography variant='h6' gutterBottom paragraph>
        <strong>MICE</strong> groups are finally back,{" "}
        <Emoji symbol='✌️' label='victory' />
        and we feel like we are in the pink ! All this past months, we have been
        talking to you guys, and we have listened what the new necessities are
        now for the <strong>MICE</strong> Market, now that ... this thingy is
        over <Emoji symbol='😷' label='coronavirus' /> ehem...
      </Typography>
      <Divider />
      <br /> <br />
      <Typography variant='h6' gutterBottom paragraph>
        It took time, but our Operations Team have managed to curate a program
        that has it all, This offer is based on a 5-star 100% certified
        eco-resort 20 mins north of <strong>Barcelona</strong>, and surrounded
        by nature .
        <Emoji symbol='🌲' label='nature' />
      </Typography>
      <Typography
        variant='h6'
        gutterBottom
        paragraph
        style={{ margin: "1rem 1.5rem" }}
      >
        <Emoji symbol='👉' label='finger' />
        {"    "}
        For <strong>day 1</strong>, we have prepared a 1/2 meeting, and a
        pic-nic lunch among vineyards, with sea-views and a great wine activity.
      </Typography>
      <Typography
        variant='h6'
        gutterBottom
        paragraph
        style={{ margin: "1rem 1.5rem" }}
      >
        <Emoji symbol='👉' label='finger' />
        {"    "}
        For <strong>day 2</strong>, we actually spend the day in Barcelona. We
        first enjoy a specialised tour at the @22 district, well known as a
        major hub in the South of Europe for digital entrepreneurs, and tech
        start ups.
      </Typography>
      <Typography variant='h6' gutterBottom>
        The tour will raise awareness of all the high-tech infraestructure, the{" "}
        <strong>IOT </strong>(Internet of Things) present in everyday life urban
        objects, and the policies that have transformed{" "}
        <strong>Barcelona</strong> to a capital for Mobile
        <Emoji symbol='📱' label='phone' />, Startups and SmartCities.
      </Typography>
      <Typography variant='h6' gutterBottom>
        Last, but not least - we are offering a first-in-class experience at
        Valkiria - an extraordinary atelier, where the group will be immersed in
        a vibrant <strong>Design Thinking</strong> workshop.
        <Emoji symbol='🤗' label='hug' /> This workshop can be extremely useful
        for the individual participants, as well as at a company level
      </Typography>
      <div className={classes.action}>
        <Button
          variant='contained'
          size='large'
          startIcon={<EmailIcon />}
          style={{ margin: "2rem 0 ", backgroundColor: "#ea5933" }}
        >
          <a
            className={classes.link}
            href='mailto:miranda@cuttingedge-events.com'
          >
            Send me an email{" "}
            <span className={classes.extendText}>to learn more ...</span>
          </a>
        </Button>
        <br />
        <Typography variant='h6'>
          Or get in touch at miranda@cuttingedge-events.com
        </Typography>
      </div>
    </Paper>
  );
};

export default Explanation;

const useStyles = makeStyles((theme) => ({
  explanation: {
    width: "50%",
    height: "auto",
    padding: theme.spacing(2),
    marginTop: theme.spacing(5),
    alignSelf: "center",
    border: "none",
    color: "#ea5933",
    fontWeight: 900,
    "& strong": {
      fontSize: "1.3rem",
      color: "green",
    },
    [theme.breakpoints.down("sm")]: {
      width: "90%",
    },
  },

  link: {
    color: "#fff",
    fontWeight: "bold",
    fontSize: "1rem",
    textDecoration: "none",
    fontStyle: "italic",
  },
  action: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    "& button:hover": {
      backgroundColor: "#ccc !important",
    },
  },
  extendText: {
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
}));
